/* FEATURED PRODUCT */
class FeaturedProduct extends MainProduct {
  onVariantChange(event) {
    this.requestedOptionValues = event.detail?.selectedOptions || [];

    /* build-for-combined-listings - shopify plus store */
    const siblingUrl = event.detail?.productUrl;
    if (siblingUrl && siblingUrl !== this.productUrl) {
      const params = this.requestedOptionValues.length
        ? "?option_values=" + encodeURIComponent(this.requestedOptionValues.join(","))
        : "";
      window.location.href = siblingUrl + params;
      return;
    }

    super.onVariantChange(event);
  }

  updateInfo(doc) {
    const container = doc.querySelector("featured-product");
    if (!container) return;

    this.innerHTML = container.innerHTML;

    this.markUnsoldCombination();
    this.reinitializePickupAvailability();

    requestAnimationFrame(() => {
      this.restoreFocus(this.lastFocusedSignature);
    });
  }


  markUnsoldCombination() {
    const requested = this.requestedOptionValues;
    if (!requested?.length) return;

    const rendered = this.selectedOptionValues;
    const isSold = requested.every((value) => rendered.includes(value));
    if (isSold) return;

    const button = this.querySelector(".product_form_submit_btn");
    const label = button?.querySelector(".btn_text");
    const idInput = this.querySelector('input[name="id"]');
    const dynamicButton = this.querySelector(".shopify-payment-button");

    if (idInput) idInput.disabled = true;

    if (button) {
      button.disabled = true;
      button.dataset.available = "false";
    }

    if (label && this.dataset.unavailableText) {
      label.textContent = this.dataset.unavailableText;
    }

  
    if (dynamicButton) dynamicButton.hidden = true;
  }

 
  get selectedOptionValues() {
    const selected = Array.from(
      this.querySelectorAll("variant-picker select"),
    ).map((select) => select.selectedOptions[0]?.dataset.value);

    const checked = Array.from(
      this.querySelectorAll('variant-picker input[type="radio"]:checked'),
    ).map((radio) => radio.dataset.value);

    return [...selected, ...checked].filter(Boolean);
  }
}

if (!customElements.get("featured-product")) {
  customElements.define("featured-product", FeaturedProduct);
}
